import axios from "axios";
import { baseUrl } from "../common/siteSettings";
import heyapi from "../middleware/axiosInstance"

export const post = async (url, data) => {
    try {
        const res = await heyapi.post(baseUrl + url, data)
        return { statusCode: res.status, data: res.data };
    }
    catch (e) {
        console.log(e)
        return {
            statusCode: e?.response?.data?.error?.statusCode || 404,
            message: (e.response.data === undefined) ? e?.message : e?.response?.data?.error?.message
        }
    }
}

export const patch = async (url, data) => {
    try {
        const res = await heyapi.patch(baseUrl + url, data)
        return { statusCode: res.status, data: res.data };
    }
    catch (e) {
        console.log(e)
        return {
            statusCode: e?.response?.data?.error?.statusCode || 404,
            message: (e.response.data === undefined) ? e?.message : e?.response?.data?.error?.message
        }
    }
}

export const get = async (url) => {
    try {
        const res = await heyapi.get(baseUrl + url);
        return { statusCode: res.status, data: res.data }
    }
    catch (err) {
        console.log(err)
    }
}

export const deletethis = async (url) => {
    try {
        const res = await heyapi.delete(baseUrl + url);
        return { statusCode: res.status, data: res.data }
    }
    catch (err) {
        console.log(err)
    }
}